import type { LucideIcon } from 'lucide-react';
import {
  Armchair,
  Bath,
  Bike,
  Briefcase,
  Building2,
  Car,
  CookingPot,
  Coffee,
  Dumbbell,
  Flame,
  Flower2,
  Gamepad2,
  KeyRound,
  Laptop,
  Leaf,
  Lock,
  Mountain,
  Package,
  Palette,
  PawPrint,
  PlugZap,
  Refrigerator,
  ShieldCheck,
  Shirt,
  Snowflake,
  Sofa,
  Sparkles,
  Sun,
  Trees,
  Tv,
  Utensils,
  Waves,
  Wifi,
  Wind,
} from 'lucide-react';

const RULES: Array<[RegExp, LucideIcon]> = [
  [/\b(ev|electric vehicle|charg)/i, PlugZap],
  [/pool|swim|spa|hot tub|jacuzzi/i, Waves],
  [/fitness|gym|yoga|peloton|weights|cardio|train/i, Dumbbell],
  [/pet|dog|cat|bark|paw/i, PawPrint],
  [/bike|bicycle|cycl/i, Bike],
  [/storage|package|locker|parcel|deliver/i, Package],
  [/art|mural|gallery|sculpt/i, Palette],
  [/pollinator|bee|garden|flower/i, Flower2],
  [/landscap|native|drought|green|sustainab|leed/i, Leaf],
  [/park(?!ing)|trail|outdoor|courtyard|acre|lawn/i, Trees],
  [/wi-?fi|internet|broadband|fiber/i, Wifi],
  [/parking|garage|carport/i, Car],
  [/washer|dryer|laundry/i, Shirt],
  [/office|co-?work|business|conference|meeting/i, Briefcase],
  [/study|computer|work from home/i, Laptop],
  [/grill|bbq|barbecue|fire ?pit|fireplace/i, Flame],
  [/kitchen|cook|range|oven/i, CookingPot],
  [/refrigerator|fridge|appliance|stainless/i, Refrigerator],
  [/coffee|caf[eé]|espresso/i, Coffee],
  [/dining|restaurant|bar\b|lounge.*dinner|supper/i, Utensils],
  [/view|mountain|cascade|skyline/i, Mountain],
  [/sun|rooftop|deck|terrace|patio|balcon/i, Sun],
  [/air condition|a\/c|hvac|merv|filter|ventilat/i, Wind],
  [/heat|cold|climate/i, Snowflake],
  [/lounge|clubhouse|lobby|social/i, Sofa],
  [/closet|shelv|built-in|cabinet/i, Armchair],
  [/game|billiard|media room/i, Gamepad2],
  [/tv|cable|theater|theatre/i, Tv],
  [/bath|tub|shower/i, Bath],
  [/gate|controlled access|secur|camera/i, ShieldCheck],
  [/key|smart lock|keyless/i, KeyRound],
  [/lock/i, Lock],
  [/retail|shop|store|elevator|building/i, Building2],
];

/** Picks a line icon from an amenity title; falls back to a neutral sparkle. */
export function amenityIcon(title: string | null | undefined): LucideIcon {
  const text = title || '';
  for (const [re, Icon] of RULES) {
    if (re.test(text)) return Icon;
  }
  return Sparkles;
}
